var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsEyeOff = function SvgPartsEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.616 16.211c-1.19 2.921-3.878 5.208-7.244 6.14a7.24 7.24 0 0 0 3.866-6.399 7.24 7.24 0 0 0-3.866-6.4c3.366.932 6.054 3.219 7.244 6.14a.69.69 0 0 1 0 .519m-21.232 0a.69.69 0 0 1 0-.519c1.19-2.921 3.878-5.208 7.245-6.14a7.24 7.24 0 0 0-3.867 6.4 7.24 7.24 0 0 0 3.866 6.4c-3.367-.933-6.054-3.22-7.244-6.141M16 22.428a6.483 6.483 0 0 1-6.476-6.476A6.483 6.483 0 0 1 16 9.476a6.484 6.484 0 0 1 6.476 6.476A6.484 6.484 0 0 1 16 22.428m11.674-7.167C25.894 10.889 21.202 7.952 16 7.952s-9.893 2.937-11.675 7.309a1.82 1.82 0 0 0 0 1.38C6.107 21.015 10.8 23.953 16 23.953s9.893-2.938 11.674-7.31a1.82 1.82 0 0 0 0-1.381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.133 14.733a.914.914 0 0 1-.914-.915c0-.208.073-.399.191-.553a3 3 0 0 0-1.41-.36 3.048 3.048 0 1 0 3.047 3.047c0-.511-.137-.987-.36-1.41a.9.9 0 0 1-.554.19"
  }))));
};
export default SvgPartsEyeOff;